/**
 * Created by jv on 18/04/2017.
 */
const utils = require("Sources/utils/utils");

module.exports = class Customer
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.key = options.key;
    this.identification = options.identification;

    this.type = options.type;
    this.description = options.description;
    this.country = options.country;
  }

  get readableCountry()
  {
    switch(this.country)
    {
      case "BE":
        return "globals.countries.belgium";
      case "NL":
        return "globals.countries.netherlands";
      default:
        return this.country;
    }
  }
}



// WEBPACK FOOTER //
// ./app/js/models/admin/customer.js